const buildConfinedAppSwitchHref = (
	link: string,
	android: boolean,
	location: { host: string; origin: string }
): string =>
	android
		? `intent://${location.host}${link}#Intent;scheme=https;S.browser_fallback_url=${encodeURIComponent(`${location.origin}${link}`)};end`
		: `${location.origin}${link}`;

export default buildConfinedAppSwitchHref;
